import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './registerServiceWorker'

// import Vddl from 'vddl';
import VueDragDrop from 'vue-drag-drop';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.config.productionTip = false
// Vue.use(Vddl);
Vue.use(VueDragDrop);
Vue.component('VueSlider', VueSlider);

// Converts from degrees to radians.
Math.radians = function(degrees) { return degrees * Math.PI / 180; };

// Converts from radians to degrees.
Math.degrees = function(radians) { return radians * 180 / Math.PI; };

new Vue({
	store,
	render: h => h(App)
}).$mount('#app')
